import * as tf from '@tensorflow/tfjs'
import { SSD } from '../helpers/ssd'
const ssd = new SSD()

export default class DetectManager {
    instance = null
    constructor() {
        if (!this.instance) {
            this.instance = new DetectManagerImplement()
        }
        return this.instance
    }
}

class DetectManagerImplement {
    constructor() {
        this.predict_option = {
            NMS: true,
            alpha_box: false,
            show_score: false,
        }
        ssd.predict(tf.zeros([256, 256, 3]))
    }

    async predict({ snapshot, w, h }) {
        let pixels = undefined
        let external_tensor = false
        if (snapshot instanceof tf.Tensor) {
            external_tensor = true
            pixels = snapshot
        } else pixels = tf.browser.fromPixels(snapshot)

        let startTime = performance.now()
        const result = await ssd.predict(pixels)
        if (!external_tensor) pixels.dispose()
        // await tf.nextFrame()
        const boxes = ssd.decode_predict(result, this.predict_option.NMS, {
            w: w,
            h: h,
        })

        const inferenceTime = performance.now() - startTime

        return boxes
    }
}
